import styled from "styled-components";

export const OrderedList = styled.ol`
  margin: 0;
  padding: 0;
`;

export const UnorderedList = styled.ul`
  margin: 0;
  padding: 0;
`;
